<script>
  import * as PropTypes from "prop-types";
  const { checkPropTypes, func, string, bool } = PropTypes;
  import { onMount } from "svelte";
  export let ZIndex,
    _onCloseHandler,
    preventDismissOnInnerTap = false,
    fullScreen,
    Bgc = "bg-white";

  const propTypes = {
    ZIndex: string,
    _onCloseHandler: func,
    preventDismissOnInnerTap: bool,
    fullScreen: bool,
    Bgc: string,
  };
  onMount(() => {
    checkPropTypes(propTypes, $$props, "prop", "Modal");
  });

  const fullScreenClasses = fullScreen ? `h-full` : ``;

  const _onClose = () => {
    if (_onCloseHandler) {
      _onCloseHandler(false);
    } else {
      history.goBack();
    }
  };

  const _onInnerTap = (e) => {
    if (preventDismissOnInnerTap) {
      e.stopPropagation();
    }
  };
</script>

<div
  on:click={_onClose}
  on:touchstart={(e) => e.stopPropagation()}
  on:mousedown={(e) => e.stopPropagation()}
  class={`left-0 w-full top-0 h-full absolute ${ZIndex} bg-modal`}
>
  <div
    on:click={_onInnerTap}
    class={`absolute top-0 left-0 w-full ${fullScreenClasses} ${Bgc}`}
  >
    <slot />
  </div>
</div>

<style></style>
